import { render, staticRenderFns } from "./WelfarePointDetail.vue?vue&type=template&id=0b0e2024"
import script from "./WelfarePointDetail.vue?vue&type=script&lang=js"
export * from "./WelfarePointDetail.vue?vue&type=script&lang=js"
import style0 from "./WelfarePointDetail.vue?vue&type=style&index=0&id=0b0e2024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports